import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative flex items-center"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center"
}

import { computed, type PropType } from 'vue';
import { BaseIcon } from '@/lib/components/Icon';
import { LoadingIcon } from '@/lib/components/Loading';
import { ButtonColors } from '@/lib';
import NumberBadge from '@/lib/components/Badge/NumberBadge.vue';

type NumberBadgeColor = 'primary' | 'white' | 'danger';


export default /*@__PURE__*/_defineComponent({
  __name: 'BadgeIconButton',
  props: {
  /**
   * A vue-Router object or string specifying the URL to navigate to
   */
  to: {
    type: [String, Object],
    default: null
  },
  rightIcon: {
    type: String,
    default: ''
  },
  leftIcon: {
    type: String,
    default: ''
  },
  badgeNumber: {
    type: [String, Number],
    default: 0
  },
  badgeEnabled: {
    type: Boolean,
    default: true
  },
  badgeColor: {
    type: String as PropType<NumberBadgeColor>,
    default: 'white',
    validator: (value: NumberBadgeColor) =>
      ['white', 'primary', 'danger'].includes(value)
  },
  color: {
    type: String,
    default: 'primary',
    validator: (value: ButtonColors) =>
      [
        'primary',
        'primary-600',
        'secondary',
        'success',
        'alert',
        'danger',
        'ghost',
        'muted',
        'gray',
        'gray-200',
        'gray-900',
        'dark',
        'clear',
        'tertiary',
        'primary-outline',
        'danger-outline'
      ].includes(value)
  },
  size: {
    type: String,
    default: 'regular',
    validator: (value: string) =>
      ['sm', 'small', 'regular', 'large', 'xl'].includes(value)
  },
  block: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  showZeroBadge: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;
const showBadge = computed(() => {
  const badgeValue = String(props.badgeNumber);
  return badgeValue !== '' && (badgeValue !== '0' || props.showZeroBadge);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.to ? 'router-link' : 'button'), {
    to: __props.to,
    type: __props.to ? undefined : 'button',
    class: _normalizeClass(["relative btn focus:outline-none", [
      __props.disabled ? 'btn-disabled' : `btn-${__props.color}`,
      __props.block ? 'btn-block' : '',
      `btn-${__props.size}`,
      __props.loading ? 'cursor-wait' : ''
    ]]),
    disabled: __props.disabled || __props.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["flex flex-row items-center", { 'opacity-0': __props.loading }])
      }, [
        (__props.leftIcon?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(BaseIcon), {
                name: __props.leftIcon,
                position: "left",
                class: "stroke-1.5",
                height: '18px'
              }, null, 8, ["name"])
            ]))
          : _createCommentVNode("", true),
        (showBadge.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({
          'inline-block': true,
          'mr-3 -ml-2': __props.leftIcon?.length,
          'mr-3': !__props.leftIcon?.length
        })
            }, [
              _createVNode(NumberBadge, {
                "badge-number": __props.badgeNumber,
                "is-enabled": __props.badgeEnabled,
                color: __props.badgeColor
              }, null, 8, ["badge-number", "is-enabled", "color"])
            ], 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default"),
        (__props.rightIcon?.length)
          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 2,
              class: "order-1 stroke-1.5",
              name: __props.rightIcon,
              position: "right"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_unref(LoadingIcon))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["to", "type", "disabled", "class"]))
}
}

})